import { ENTRY_ID } from '@doda/common/src/constants/clicksCountUp';

const BASE_APPLY_LINK = '/dcfront/member/memberRegist/';
type JobOfferType = 'Direct' | 'Agent';

/**
 * 求人カード応募リンク作成処理
 * @param {JobOfferType} type - 求人の種類 ('Direct' または 'Agent')
 * @param {string} jid - 求人ID
 * @returns {string} 応募リンクURL
 */
export function createApplyingLink(type: JobOfferType, jid) {
  if (type === 'Agent')
    return `${BASE_APPLY_LINK}?carry_id=${jid}&carry_class=o&entry_id=${ENTRY_ID.support}&fm=list`;
  return `${BASE_APPLY_LINK}?carry_id=${jid}&carry_class=d&entry_id=${ENTRY_ID.direct}&fm=list`;
}
